import { useParams, useSearchParams } from 'react-router-dom';

import { useExchangeOneTimeToken } from '@/pages/members/hooks/useExchangeOneTimeToken';
import Spinner from '@/ui/members/components/Spinner';

const OneTimeLogin = () => {
  const { uid, token } = useParams<{ uid: string; token: string }>();
  const [searchParams] = useSearchParams();
  const next = searchParams.get('next');

  useExchangeOneTimeToken(uid, token, next);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <Spinner label="Logging you in..." />
    </div>
  );
};

export default OneTimeLogin;
